import React from "react";
import Helper from "../../Helper/helper";
import VideoDescriptionBody from "./VideoDescriptionBody";

import { translate } from "react-multi-lang";

class VideoDetails extends Helper {
    render() {
        const { t } = this.props;

        const { videoDetailsFirst } = this.props;

        const detailsText =
            videoDetailsFirst.details == null
                ? ""
                : String(videoDetailsFirst.details);

        return (
            <div className="slider-topbottom-spacing slider-overlay">
                <h1 className="banner_video_title">
                    {videoDetailsFirst.title}
                </h1>
                <div className="row">
                    <div className="col-lg-8 col-xl-8">
                        <h4 className="detail-head">{t("details")}</h4>
                        <div className="details-text">
                            <VideoDescriptionBody
                                text={detailsText}
                                linkPreview={
                                    videoDetailsFirst.details_link_preview ||
                                    null
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate(VideoDetails);
